export enum AppRoutes {
  TreatmentSelection = "/treatment-selection",
  Result = "/result",
  Checkout = "/checkout",
  PaymentCompleted = "/payment-completed/",
}
